import { Skeleton } from '@root/shared/ui-kit'

import { PremiumCardHeaderSkeleton } from '../premium-card-header/premium-card-header-skeleton'

import {
  Actions,
  ActivePremiumCardRoot,
  DaysLeft,
  Footer,
  FooterContent,
  Header,
  Rows,
  TimeLeft,
} from './active-premium-card'

export const ActivePremiumCardSkeleton: React.FC = () => {
  return (
    <ActivePremiumCardRoot>
      <Header>
        <PremiumCardHeaderSkeleton />
      </Header>
      <Footer>
        <FooterContent>
          <Rows>
            <TimeLeft>
              <Skeleton.Line width={'20ch'} />
            </TimeLeft>
            <DaysLeft>
              <Skeleton.Line width={'10ch'} />
            </DaysLeft>
          </Rows>
          <Actions>
            <Skeleton width={108} height={32} />
            <Skeleton width={32} height={32} />
          </Actions>
        </FooterContent>
      </Footer>
    </ActivePremiumCardRoot>
  )
}
